import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { AccessTab } from "./admin/AccessTab";
import { UploadTab } from "./admin/UploadTab";
import { ManagersTab } from "./admin/ManagersTab";
import { SettingsTab } from "./admin/SettingsTab";
import { LogsTab } from "./admin/LogsTab";

type AdminTab = "access" | "upload" | "managers" | "settings" | "logs";

export function AdminScreen() {
  const { setShowAdmin, t, adminInitialTab, setAdminInitialTab } = useAuth();
  const [tab, setTab] = useState<AdminTab>(
    (adminInitialTab as AdminTab | null) ?? "access"
  );

  function close() {
    setAdminInitialTab(null);
    setShowAdmin(false);
  }

  return (
    <div className="fixed inset-0 z-50 bg-slate-100 flex flex-col">
      <header className="bg-gradient-to-br from-indigo-600 to-violet-600 text-white px-5 pt-12 pb-3 flex items-center justify-between flex-shrink-0">
        <div className="text-base font-semibold">⚙ Админ-панель</div>
        <button
          onClick={close}
          className="bg-white/15 hover:bg-white/25 text-white text-xs font-semibold rounded-full px-3 py-1.5 transition"
        >{t("admin_close")}</button>
      </header>

      <div className="flex bg-white border-b border-slate-200 flex-shrink-0">
        <button
          onClick={() => setTab("access")}
          className={`flex-1 py-3 text-sm font-medium ${tab === "access" ? "text-indigo-600 border-b-2 border-indigo-600" : "text-slate-500"}`}
        >{t("admin_tab_access")}</button>
        <button
          onClick={() => setTab("upload")}
          className={`flex-1 py-3 text-sm font-medium ${tab === "upload" ? "text-indigo-600 border-b-2 border-indigo-600" : "text-slate-500"}`}
        >{t("admin_tab_upload")}</button>
        <button
          onClick={() => setTab("managers")}
          className={`flex-1 py-3 text-sm font-medium ${tab === "managers" ? "text-indigo-600 border-b-2 border-indigo-600" : "text-slate-500"}`}
        >{t("admin_tab_managers")}</button>
        <button
          onClick={() => setTab("settings")}
          className={`flex-1 py-3 text-sm font-medium ${tab === "settings" ? "text-indigo-600 border-b-2 border-indigo-600" : "text-slate-500"}`}
        >{t("admin_tab_settings")}</button>
        <button
          onClick={() => setTab("logs")}
          className={`flex-1 py-3 text-sm font-medium ${tab === "logs" ? "text-indigo-600 border-b-2 border-indigo-600" : "text-slate-500"}`}
        >{t("admin_tab_logs")}</button>
      </div>

      <main className="flex-1 overflow-y-auto">
        {tab === "access" && <AccessTab />}
        {tab === "upload" && <UploadTab />}
        {tab === "managers" && <ManagersTab />}
        {tab === "settings" && <SettingsTab />}
        {tab === "logs" && <LogsTab />}
      </main>
    </div>
  );
}
